import { ApplicationRef, Injectable } from "@angular/core";
import { configureChains, connect, fetchBalance, prepareWriteContract, readContracts, switchNetwork, watchAccount, watchNetwork, writeContract, disconnect, waitForTransaction, createConfig, mainnet } from '@wagmi/core'
import { HttpClient } from '@angular/common/http';
import { publicProvider } from '@wagmi/core/providers/public';
import { jsonRpcProvider } from '@wagmi/core/providers/jsonRpc';
import { MetaMaskConnector } from '@wagmi/core/connectors/metaMask';
import { WalletConnectConnector } from '@wagmi/core/connectors/walletConnect';
import { TranslateService } from '@ngx-translate/core';
import { formatEther, parseEther } from 'viem';
import { bsc, bscTestnet, goerli } from 'viem/chains';

import { PopupService } from './popup.service';
import { EventService } from './event.service';
import { SwapStatus, getParam } from '../shared/constants/app-enums';
import { environment } from 'src/environments/environment';


/**
 * variable used for the presale smart contract
 * of different network
 */
const staking = require('src/assets/contracts/staking.json');
const presaleEth = require('src/assets/contracts/presaleETH.json');
const presaleBsc = require('src/assets/contracts/presaleBSC.json');
const token = require('src/assets/contracts/token.json');


/**
 * here the presale ABI and Address are set
 * for read, write and prepair contract
 */
const stakeContract = {
  address: environment.stakingAddress as any,
  abi: staking.abi,
}

const presaleContractEth = {
  address: environment.eth.presaleAddress as any,
  abi: presaleEth.abi,
}

const presaleContractBsc = {
  address: environment.bsc.presaleAddress as any,
  abi: presaleBsc.abi,
}
const tokenContract = {
  address: environment.tokenAddress as any,
  abi: token.abi,
}

@Injectable({
  providedIn: 'root'
})

export class WalletConnectService {

  swapStatus = SwapStatus.not_started;
  walletAddress: string = '';
  referUrl: string = '';
  client: any;
  wagmiData: any;
  chainId: any;
  mode: any;

  presaleData: any;
  swapHash: any = '';
  refreshId: any;
  refreshRate: number = 5000;

  /* variables used for Wallet connection */

  metaMaskConnector: any;
  walletConnector: any;

  /* predefined values of the essential variables */

  balanceData: {
    nativeBal: number,
    usdtBal: number,
    ethTokenSold: number,
    bscTokenSold: number,
    totalTokensSold: number,
    ethClaimable?: number,
    bscClaimable?: number,
    userClaimable: number,
    currentStep: number,
    startTime?: any,
    endTime?: any,
    paused?: boolean,
    usdRaised?: number,
    maxTokensToBuy?: number,
    oneEth: number,
    oneBnb: number,
    ethUsdt: number,
    bnbUsdt: number
  } = {
      nativeBal: 0,
      usdtBal: 0,
      ethTokenSold: 0,
      bscTokenSold: 0,
      totalTokensSold: 0,
      ethClaimable: 0,
      bscClaimable: 0,
      userClaimable: 0,
      startTime: '',
      endTime: '',
      paused: false,
      currentStep: 0,
      usdRaised: 0,
      maxTokensToBuy: 0,
      oneEth: 0,
      oneBnb: 0,
      ethUsdt: 0,
      bnbUsdt: 0
    }

  stakeData: {
    userStaked: number,
    totalStaked: number,
    rewardPerRound: number,
    userPoolPercent: number,
    apy: number,
    unlockTime: number,
    userReward: number,
    userBal: number,
    isClaimEnabled: boolean
  } = {
      userStaked: 0,
      totalStaked: 0,
      rewardPerRound: 0,
      userPoolPercent: 0,
      apy: 0,
      unlockTime: 0,
      userReward: 0,
      userBal: 0,
      isClaimEnabled: false
    }

  /**
   * Tokenomics data is defining the no of preslae stages,
   * price of each token, minimum and maximum no of token
   * for each stages. It is also defining the end date of each presale stages.
   */
  tokenomics = [
    {
      "minToken": 0,
      "maxToken": 20108695652,
      "maxAmount": 1850000,
      "tokenUSDT": 0.00009200,
      "title": "softcap_title",
      "endDate": 9684936022000
    },
    {
      "minToken": 20108695652,
      "maxToken": 40000000000,
      "maxAmount": 3680000,
      "tokenUSDT": 0.00009200,
      "title": "hardcap_title",
      "endDate": 9684936022000
    }
  ]

  constructor(
    private http: HttpClient,
    private appRef: ApplicationRef,
    private eventService: EventService,
    private popupService: PopupService,
    private transletService: TranslateService,
  ) { }


  /**
   * This function is getting called from banner.ts file
   */

  async activateSite() {

    /**
     * Wagmi Core chain, provider and connector configuration.
     * If production mode then mainnet and paid RPC provider else
     * testnet and publicProvider
     */

    const currentChain: any = environment.production ? [mainnet, bsc] : [goerli, bscTestnet];
    const { chains, publicClient, webSocketPublicClient } = configureChains(
      currentChain,
      environment.production ?
        [
          jsonRpcProvider({
            rpc: (chain) => ({
              http: chain.id === environment.eth.chainIdInt ? environment.eth.rpcURL : environment.bsc.rpcURL,
            }),
          }),
          jsonRpcProvider({
            rpc: (chain) => ({
              http: chain.id === environment.eth.chainIdInt ? environment.eth.backupRPC : environment.bsc.backupRPC,
            }),
          })
        ]
        : [publicProvider()]
    )


    /**
     * Setup of Metamask connector which will work
     * with metamask browser extension
     */

    this.metaMaskConnector = new MetaMaskConnector({
      chains: chains,
    })



    /**
     * Setup of wallet connector v2 which will work
     * with mobile app like trustwallet, alphawallet app.
     * the projectId is mandatory and can be generated from
     * https://cloud.walletconnect.com/sign-in
     */

    this.walletConnector = new WalletConnectConnector({
      chains,
      options: {
        projectId: environment.walletConnectId
      },
    })


    /**
     * wagmi createConfig setup for auto connect feature
     * and available connectors of wagmi.
     */

    this.client = createConfig({
      autoConnect: true,
      connectors: [this.metaMaskConnector, this.walletConnector],
      publicClient,
      webSocketPublicClient,
    });



    /**
     * watchNetwork function continuously monitors the user’s
     * connected network. Whenever user switched/changed its
     * current network, this function keeps tracking that data
     * and updates the current chain id accordingly.
     */

    watchNetwork((network: any) => {
      this.chainId = network?.chain?.id;
      this.eventService.isBsc = this.chainId == environment.bsc.chainIdInt;
      this.getPresalesData();
      setTimeout(() => this.eventService.setNetwork(), 2000);
      this.appRef.tick();
      console.log('watchNetwork =', network);
    });


    /**
     * This function continuously monitors the user’s connected
     * wallet account. Whenever user switched/changed its current account,
     * this function updates the current wallet address accordingly.
     */
    watchAccount((account: any) => this.setData(account));

  }


  /**
   * this is connect wallet function. The mode argument
   * is actually providing a choice to the app user whether
   * they want to connect via Metamask, WalletConnect V2 or web3Auth.
   * This function is mainly called from connect modal component.
   */

  async connectWallet(mode: string) {
    this.mode = mode;
    await connect({
      connector: mode === 'metamask' ? this.metaMaskConnector : this.walletConnector,
      chainId: this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt
    })
      .then((success: any) => {
        console.log('\n==== wallet connected ====\n', this.client, '\n====');
        setTimeout(() => {
          this.sendDashFx('', 0, 0, true);
          this.windowDataLayer('connectWallet', 'successful', 2, 1, 0, '', '', 0, 0);
        }, 2000);
      },
        (err: any) => {
          console.log('\n==== wallet connection issue ====\n', err, '\n====');
        })
  }


  /**
   * this is disconnect wallet function. After a successful disconnection
   * a developer can reset the different variables values.
   */

  async disConnectWallet() {
    await disconnect()
      .then((success: any) => {
        console.log('\n==== wallet disconnected ====\n', this.client);
        localStorage.clear();
        this.chainId = null;
        this.walletAddress = '';
        this.referUrl = '';
        this.balanceData.nativeBal = 0;
        this.balanceData.usdtBal = 0;
        this.eventService.setNetwork();
        this.eventService.isConnected = false;
      },
        (err: any) => {
          console.log('\n==== wallet disconnect issue ====\n');
          console.log('disconnect issue =', err);
        })
  }


  /**
   * This function is getting called from watchAAccount.
   * Here we are saving the wagmi wallet address and
   * also calling the getPresale function for re-read
   * the smart contract function with new wallet address
   */

  setData(account: any): void {
    this.wagmiData = account;
    this.walletAddress = this.wagmiData.address;
    this.refreshRate = account.address ? 5000 : 20000;
    this.eventService.isConnected = account.address ? true : false;
    this.appRef.tick();
    this.getPresalesData();
    console.log('wagmiData', this.wagmiData);
  }


  /**
   * In thiss fnctiion we are calling the different method
   * of smart contract to get different values
   */

  async getPresalesData() {
    if (this.walletAddress && this.referUrl == '') {
      this.refer();
    }
    const config = {
      contracts: [
        {
          ...presaleContractEth,
          functionName: 'totalTokensSold',     // this method is returning the no of tokens sold via BSC
          chainId: environment.eth.chainIdInt, // 0
          args: []
        },
        {
          ...presaleContractEth,
          functionName: 'ethBuyHelper',         // this method is returning the amount of bnb required for 1 app token.
          chainId: environment.eth.chainIdInt, // 1
          args: [1]
        },
        {
          ...presaleContractEth,
          functionName: 'usdtBuyHelper',        // this method is returning the amount of usdt required for 1 app token.
          chainId: environment.eth.chainIdInt, // 2
          args: [1]
        },
        {
          ...presaleContractEth,
          functionName: 'usdRaised',           // this method is returning the total USDT raised via BSC token.
          chainId: environment.eth.chainIdInt, // 3
          args: []
        },
        {
          ...presaleContractEth,              // 4 MAx token allowed to buy
          functionName: 'maxTokensToBuy',
          chainId: environment.eth.chainIdInt,
          args: []
        },

        // =========== BSC Contract ==============

        {
          ...presaleContractBsc,
          functionName: 'totalTokensSold',     // this method is returning the no of tokens sold via BSC
          chainId: environment.bsc.chainIdInt, // 5
          args: []
        },
        {
          ...presaleContractBsc,
          functionName: 'bnbBuyHelper',         // this method is returning the amount of bnb required for 1 app token.
          chainId: environment.bsc.chainIdInt, // 6
          args: [1]
        },
        {
          ...presaleContractBsc,
          functionName: 'usdtBuyHelper',        // this method is returning the amount of usdt required for 1 app token.
          chainId: environment.bsc.chainIdInt, // 7
          args: [1]
        },
        {
          ...presaleContractBsc,
          functionName: 'usdRaised',           // this method is returning the total USDT raised via BSC token.
          chainId: environment.bsc.chainIdInt, // 8
          args: []
        },
        {
          ...stakeContract,
          functionName: 'poolStakers',
          chainId: environment.eth.chainIdInt, //9
          args: [this.walletAddress || "0x0000000000000000000000000000000000000000"]
        },
        {
          ...stakeContract,
          functionName: 'getRewards',
          chainId: environment.eth.chainIdInt, //10
          args: [this.walletAddress || "0x0000000000000000000000000000000000000000"]
        },
        {
          ...stakeContract,
          functionName: 'lockedTime',
          chainId: environment.eth.chainIdInt, //11
          args: []
        },
        {
          ...stakeContract,
          functionName: 'rewardTokensPerBlock',
          chainId: environment.eth.chainIdInt, //12
          args: []
        },
        {
          ...stakeContract,
          functionName: 'tokensStaked',
          chainId: environment.eth.chainIdInt, //13
          args: []
        },
        {
          ...stakeContract,
          functionName: 'harvestLock',
          chainId: environment.eth.chainIdInt, //14
          args: []
        }

      ]
    }

    /**
     * Above contracts are going to be read.
     */

    this.presaleData = await readContracts(config);

    if (this.walletAddress) {
      let xrp20Bal = await fetchBalance({
        address: this.walletAddress as any,
        formatUnits: 'ether',
        token: environment.tokenAddress as any,
        chainId: environment.eth.chainIdInt
      });
      this.stakeData.userBal = +xrp20Bal.formatted;
    }
    console.log('\n******presaleData =', this.presaleData, '\n******\n');

    this.stakeData.userStaked = +formatEther(this.presaleData[9].result[0] || 0);
    this.stakeData.unlockTime = Number(this.presaleData[9].result[1]) + Number(this.presaleData[11].result);
    this.stakeData.userReward = +formatEther(this.presaleData[10]?.result || 0);
    this.stakeData.rewardPerRound = +formatEther(this.presaleData[12].result || 0);
    this.stakeData.totalStaked = +formatEther(this.presaleData[13].result || 0);
    this.stakeData.isClaimEnabled = !this.presaleData[14].result || false;
    this.stakeData.apy = +((+environment.apyCalcConst / this.stakeData.totalStaked) * 100).toFixed(0);


    this.balanceData.currentStep = 0; // setting current stage

    /* assigning the value of no of token sold va bsc and eth contract */
    this.balanceData.ethTokenSold = Number(this.presaleData[0].result);
    this.balanceData.bscTokenSold = Number(this.presaleData[5].result);
    this.balanceData.totalTokensSold = this.balanceData.ethTokenSold + this.balanceData.bscTokenSold;

    /* assigning the value of total USDT raised via eth and bsc */
    // this.balanceData.oneEth = +formatEther(this.presaleData[1].result); // no of app tokens in exchange of 1 eth
    // this.balanceData.ethUsdt = Number(this.presaleData[2].result);      // no of app tokens in exchange of 1 Eth USDT
    // this.balanceData.oneBnb = +formatEther(this.presaleData[6].result); // no of app tokens in exchange of 1 eth
    // this.balanceData.bnbUsdt = Number(this.presaleData[7].result);      // no of app tokens in exchange of 1 Eth USDT
    this.balanceData.usdRaised = +formatEther(this.presaleData[3].result || 0) + +formatEther(this.presaleData[8].result || 0);
    console.log(+formatEther(this.presaleData[3].result || 0), +formatEther(this.presaleData[8].result || 0))
    const tokenBuyLimit = Number(this.presaleData[4].result);
    const availableToken = this.tokenomics[1].maxToken - this.soldToken;
    this.balanceData.maxTokensToBuy = availableToken > tokenBuyLimit ? tokenBuyLimit : availableToken;

    // console.log('tokenBuyLimit', tokenBuyLimit, this.tokenomics[this.balanceData.currentStep].maxToken, this.soldToken, this.balanceData.maxTokensToBuy )
    // console.log('\n******\n RPC balanceData =', this.balanceData, '\n******\n');


    if (this.wagmiData?.isConnected) this.getMetaData(); // if user is connected then call this function
    if (this.refreshId) clearTimeout(this.refreshId);
    this.refreshId = setTimeout(() => this.getPresalesData(), this.refreshRate); // Call the self method on each 5secs interval

  }


  /**
   * This method is used to fetch the native balance
   * of the current account and network
   */

  async getMetaData() {

    const config = {
      contracts: [
        {
          ...presaleContractEth,
          functionName: 'userDeposits',         // this method is returning the total token purchased by current user via ETH network.
          chainId: environment.eth.chainIdInt,  // 1
          args: [
            this.walletAddress,
          ],
        },
        {
          ...presaleContractBsc,
          functionName: 'userDeposits',         // this method is returning the total token purchased by current user via BSC network.
          chainId: environment.bsc.chainIdInt,  // 37
          args: [
            this.walletAddress,
          ],
        },
      ],
    };

    const claimable: any = await readContracts(config);

    const nativeBalance = await fetchBalance({
      address: this.walletAddress as any,
      formatUnits: 'ether',
    })

    const usdtBal = await fetchBalance({
      address: this.walletAddress as any,
      // formatUnits: 'mwei',
      token: this.eventService.isBsc ? environment.bsc.usdTAddress as any : environment.eth.usdTAddress as any,
      chainId: this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt
    })

    /* user's Eth/Bnb and USDT balance */
    this.balanceData.nativeBal = +nativeBalance.formatted;
    this.balanceData.usdtBal = +usdtBal.formatted;

    /* assigning the value of total token purchased by the current user */
    this.balanceData.ethClaimable = +formatEther(claimable[0].result || 0)
    this.balanceData.userClaimable = this.balanceData.ethClaimable;
    // console.log('\n******\nNative Balance =', this.balanceData, '\n******\n');
  }

  /**
   * returning no of total sold tokens
   */
  get soldToken() {
    return this.balanceData.totalTokensSold;
  }


  /**
   * returning whether user is connected to the correct chain or not
   */
  isCorrectChain(): boolean {
    return this.eventService.isBsc ? (this.chainId === environment.bsc.chainIdInt) : (this.chainId === environment.eth.chainIdInt);
  }

  isEthChain(): boolean {
    return this.chainId === environment.eth.chainIdInt ? true : false;
  }
  /**
   * switching the current network. If user is on wrong network
   * and got error on switching then a popup
   * will appear saying to connect correct chain
   */
  async switchNetwork(chainId: number) {
    await switchNetwork({
      chainId: chainId,
    }).then((success: any) => {
      this.appRef.tick();
    },
      (err: any) => {
        const chain = this.eventService.isBsc ?
          chainId === environment.bsc.chainIdInt ? environment.bsc.chainInfo
            : environment.eth.chainInfo
          : environment.bsc.chainInfo;
        const chainName = chain.params[0].chainName;
        this.popupService.messagePopup("info", this.transletService.instant('switchNetwork', { chain_name: chainName }));
      });
  }


  /**
   * calculating the available no of token in exchange of inserted Eth amount
   */

  getEthAmount = async (amount: number) => {
    let singleAmount = this.balanceData.oneEth;
    return Math.floor(+(amount / (+singleAmount)));
  }

  getBnbAmount = async (amount: number) => {
    console.log('getBnbAmount called')
    let singleAmount = this.balanceData.oneBnb;
    return Math.floor(+(amount / (+singleAmount)));
  }

  /**
   * calculating the available no of token in exchange of inserted Usdt amount
   */

  getUSDTAmount = async (amount: number) => {
    let singleAmount = this.eventService.isBsc ? this.balanceData.bnbUsdt / Math.pow(10, 18) : this.balanceData.ethUsdt / Math.pow(10, 6);
    return Math.floor(+(amount / (+singleAmount)));
  }


  /**
   * reverse calculation required amount (eth/bnb/usdt)
   * in exchange of inserted token
   * @param amount : no of token
   * @param mode : exchange mode
   * @returns : required amount
   */

  getDynamicAmount = async (amount: number, mode: string) => {
    let singleAmount = 0;
    if (mode === 'getBnbAmount' && this.eventService.isBsc) {
      singleAmount = this.balanceData.oneBnb;
      return +(amount * singleAmount);
    }
    else if (mode === 'getUSDTAmount' && this.eventService.isBsc) {
      singleAmount = this.balanceData.bnbUsdt / Math.pow(10, 18)
      return +(amount * singleAmount);
    }
    else if (mode === 'getEthAmount' && !this.eventService.isBsc) {
      singleAmount = this.balanceData.oneEth;
      return +(amount * singleAmount);
    }
    else if (mode === 'getUSDTAmount' && !this.eventService.isBsc) {
      singleAmount = this.balanceData.ethUsdt / Math.pow(10, 6)
      return +(amount * singleAmount);
    }
    else return singleAmount;
  }



  /**
   * this function is swaping the eth token with app token
   * @param amount: app token amount
   * @param value: eth token value
   */

  async swapEthTokens(amount: number, value: number, isBuyStake = false) {

    // setting swapStatus to not started
    this.swapStatus = SwapStatus.not_started;

    /**
     * preparing a contract for swaping via smart contract
     * method of ethBuyHelper
     */
    const { request } = await prepareWriteContract({
      ...presaleContractEth,
      functionName: 'buyWithEth',
      chainId: this.chainId,
      args: [amount, isBuyStake],
      value: parseEther(`${value}`),
      // account: this.walletAddress    // Optional param. Not required!
    })

    // setting swapStatus to confirmation pending
    this.swapStatus = SwapStatus.confirm_pending;

    /**
     * Writing contract for swap process
     */
    await writeContract(request)
      .then((success: any) => {
        console.log('Eth write Contract success', success);
        this.swapStatus = SwapStatus.in_progess;
        this.windowDataLayer('swap', 'confirmTransaction', 2, 0, 0);
        this.sendDashFx('ETH', amount, value);
        this.checkTRansaction(success.hash, 'ETH', amount, value);
      },
        (err: any) => {
          console.log('swapEthTokens Error =', err)
          if (err.code === 4001) {
            this.swapStatus = SwapStatus.rejected;
          } else {
            this.swapStatus = SwapStatus.failed;
          }
        });

  }

  //  ************* Swap BNB Token **************

  async swapBnbTokens(amount: number, value: number) {
    console.log('swapBnbTokens called');
    this.swapStatus = SwapStatus.not_started;
    const { request } = await prepareWriteContract({
      ...presaleContractBsc,
      functionName: 'buyWithBNB',
      chainId: environment.bsc.chainIdInt,
      args: [amount],
      value: parseEther(`${value}`),
      // account: this.walletAddress    // Optional param. Not required!
    });

    this.swapStatus = SwapStatus.confirm_pending;
    await writeContract(request)
      .then((success: any) => {
        console.log('Bnb write Contract success', success);
        this.swapStatus = SwapStatus.in_progess;
        this.windowDataLayer('swap', 'confirmTransaction', 2, 0, 0);
        this.sendDashFx('BNB', amount, value);
        this.checkTRansaction(success.hash, 'BNB', amount, value);
      },
        (err: any) => {
          if (err.code === 4001) {
            this.swapStatus = SwapStatus.rejected;
          } else {
            this.swapStatus = SwapStatus.failed;
          }
        });
  }


  /**
   * this function is checking allowence
   * amount before swaping the usdt token with app token
   * @param amount: app token amount
   * @param value: usdt token value
   * @param afterAllowance: checking whether allowence is granted or not
   */

  async swapCryptoForUSDT(amount: number, value: number, afterAllowance = false, isBuyStake = false) {

    /**
     * preparing token contract with ABI
     */
    const tokenContract = {
      address: this.eventService.isBsc ? environment.bsc.usdTAddress as any : environment.eth.usdTAddress as any,
      abi: token.abi,
    }

    // set presale address based on current network
    const presaleAdd = this.eventService.isBsc ? environment.bsc.presaleAddress as any : environment.eth.presaleAddress as any;


    /**
     * reading allowence contract
     */
    const allowanceData = await readContracts({
      contracts: [
        {
          ...tokenContract,
          functionName: 'allowance',
          chainId: this.chainId,
          args: [this.walletAddress, presaleAdd],
        },
      ],
    })

    //  checking provided allowence value in token contract
    let allowanceValue;
    if (this.eventService.isBsc) {
      allowanceValue = +formatEther(allowanceData[0].result as any);
    } else {
      allowanceValue = Number(allowanceData[0].result) / Math.pow(10, 6);
    }
    console.log('allowanceValue =', value, allowanceValue);

    /**
     * if inserted usdt value is larger than
     * provided allowence value then it needs further approval.
     * below we are preparing contract for allowence approval
     */

    if (+value > +allowanceValue) {
      const { request } = await prepareWriteContract({
        ...tokenContract,
        chainId: this.chainId,
        functionName: 'approve',
        args: [presaleAdd, (afterAllowance || allowanceValue == 0) ? '100000000000000000000000000' : '0'],
        account: this.walletAddress as any    // Optional param. Not required!
      })

      // setting swapStatus to approval pending
      this.swapStatus = SwapStatus.approval_pending;


      // fetching transaction hash key of writing contract
      const { hash } = await writeContract(request);
      console.log('approve allowence hash key =', hash);

      /**
       * checking the approval transaction status.
       * if success and the allowence is preapproved
       * then it will call the buyUSDT function, else
       * will again go through the starting steps but this time with
       * allowence approval true mode.
       */
      await waitForTransaction({ hash })
        .then((success: any) => {
          console.log('approve Config success', success);
          if (afterAllowance) {
            this.buyUSDT(amount, value, isBuyStake);
          } else {
            this.swapCryptoForUSDT(amount, value, true, isBuyStake);
          }
        },
          (err: any) => {
            console.log('approve Config error', err);
            this.swapStatus = SwapStatus.rejected;
          });
    }

    /**
     * if inserted usdt value is smaller than
     * provided allowence value, then buyUSDT
     * function will be called and doesn't need
     * to check for allowence approval
     */

    else {
      this.buyUSDT(amount, value, isBuyStake);
    }
  }


  /**
   * this function is swaping the usdt token with app token
   * @param amount: app token amount
   * @param value: usdt token value
   * @param afterAllowance: checking whether allowence is granted or not
   */

  async buyUSDT(amount: number, value: number, isBuyStake = false) {

    /**
     * preparing a contract for swaping via smart contract
     * method of buyWithUSDT
     */
    const contract = this.eventService.isBsc ? presaleContractBsc : presaleContractEth;
    await prepareWriteContract({
      ...contract,
      functionName: 'buyWithUSDT',
      chainId: this.chainId,
      args: this.eventService.isBsc ? [amount] : [amount, isBuyStake],
      // account: this.walletAddress    // Optional param. Not required!
    })

      // if prepare contract is success
      .then(async (request: any) => {

        // setting swapStatus to confirmation pending
        console.log('usdtBuyHelper =', request)
        this.swapStatus = SwapStatus.confirm_pending;

        /**
         * Once confirmed startig write contract
         */
        await writeContract(request.request)
          .then((success: any) => {
            console.log('Eth writeContract success', success);
            this.windowDataLayer('swap', 'confirmTransaction', 2, 0, 0);  // setting windowdatalayer for analytics
            this.sendDashFx('usdt', amount, value);                       // updating dashFx data
            this.swapStatus = SwapStatus.in_progess;                      // setting swapStatus to inprogress mode
            this.checkTRansaction(success.hash, 'usdt', amount, value);   // checking transaction status
          },
            (err: any) => {
              console.log('Eth writeContract error', err);
              this.swapStatus = SwapStatus.failed;
            });
      },

        /**
         * if there is any error while preparing contract
         * like requesting more than max-token buy limit
         * then a warning popup will appear saying that
         * the max-token limitation
         */
        (err: any) => {
          this.popupService.messagePopup("warning", this.transletService.instant('max_token_exceed', { maxTokensToBuy: this.balanceData.maxTokensToBuy }), this.transletService.instant('max_token_title'));
          console.log(err.message)
        });
  }



  /**
   * this function is check the final
   * status of the current transaction
   * @param haskKey: transaction hash key
   * @param mode: Eth/Bnb/Usdt transaction
   * @param amount: no of tooken
   * @param value:  amount of eth/bnb/usdt
   */

  async checkTRansaction(haskKey: string, mode: string, amount: number, value: number) {
    await waitForTransaction({ hash: haskKey as any })
      .then((response: any) => {
        console.log('checkTansaction success', response);
        this.getMetaData(); // update the current native balance
        this.swapStatus = SwapStatus.complete;    // setting swapStatus to completed
        this.swapHash = response.transactionHash; // assigning succes transaction hash id
        this.windowDataLayer('swap', 'swapSuccessful', 3, 1, 0, mode, environment.tokenName, value, amount);
      },
        (err: any) => {
          console.log('checkTansaction error', err);
          this.getMetaData(); // update the current native balance
          this.swapStatus = SwapStatus.failed; // setting swapStatus to failed
        });
  }



  /**
   * function to update analytics data
   * @param flowName: process name like swap/connectWallet
   * @param stepName: swapSuccessful/confirmTransaction/successful
   * @param stepNo: step no of process
   * @param completeFlag: is omppletedd or not
   * @param errorCode: if any error
   * @param fromCurrency: ETH/BNB/USDT
   * @param toCurrency : ICO/APP token
   * @param fromVal: ETH/BNB/USDT value
   * @param toVal: App token value
   */
  windowDataLayer(flowName: string, stepName: string, stepNo: number, completeFlag: number, errorCode: number, fromCurrency: string = '', toCurrency: string = '', fromVal: number = 0, toVal: number = 0): void {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "workflowStep",
      walletAddress: this.walletAddress,
      workflowName: flowName,                                               // "swap",
      workflowStepNumber: stepNo,                                           // 2,
      workflowStepName: stepName,                                           // "confirmTransaction",

      workflowCompleteFlag: completeFlag,
      workflowErrorCode: errorCode,

      transactionId: completeFlag === 0 ? undefined : this.swapHash,
      swapFromValue: completeFlag === 0 ? undefined : fromVal,                // value,
      swapToValue: completeFlag === 0 ? undefined : toVal,                    // amount,
      swapFromCurrency: completeFlag === 0 ? undefined : fromCurrency,        // "ETH/BNB/USDT",
      swapToCurrency: completeFlag === 0 ? undefined : toCurrency,            // "ICO"
    });
  }



  /**
   * DashFx is another analytics feature
   * @param type : connect wallet/ETH/BNB/USDT
   * @param toValue: App token value
   * @param fromValue : ETH/BNB/USDT value
   * @param connectMode: whether it is wallet connect or not
   */

  sendDashFx = (type: string, toValue: number, fromValue: number, connectMode: boolean = false) => {
    const tokens: any = (this.balanceData.ethClaimable || 0);
    const data = {
      walletAddress: this.walletAddress,
      iid: environment.iidDashFx,
      event: connectMode ? 'lead_success' : (tokens > toValue ? 'revenue' : 'conversion'),
      purchaseType: connectMode ? null : type,
      purchaseTokens: +toValue,
      purchaseTypeAmount: +fromValue,
      purchaseUsdAmount: type === 'usdt' ? +fromValue : +(+(toValue * this.tokenomics[this.balanceData.currentStep].tokenUSDT).toFixed(2)),
      ipAddress: '',
      clickId: getParam('clickId'),
      source: getParam('source')
    }
    console.log('DashFx data =', tokens, data)
    this.http.post(environment.urlDashFx, data).subscribe((res: any) => {
      console.log('DashFx success response', res);
    },
      (err: any) => {
        console.log('DashFx error response', err);
      })
  }


  /**
   * Function to claim of purchased token by the user.
   * Once the presale stage is over, user can claim his token.
   * We are using eth based claim only. This function is
   * preparing a claim contract with a claim method.
   */

  async claim() {
    console.log('Claim called');
    const { request } = await prepareWriteContract({
      ...presaleContractEth,
      functionName: 'claim',
      chainId: environment.eth.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })

    await writeContract(request)
      .then((success: any) => {
        console.log('Claim success', success);
      },
        (err: any) => {
          console.log('Claim error', err);
        });
  }

  refer() {
    if (!this.walletAddress || this.walletAddress == '') return;
    const data = {
      walletAddress: this.walletAddress,
      iid: environment.iidDashFx,
    };
    this.http.post(environment.referUrl, data).subscribe((res: any) => {
      console.log('DashFx success response', res);
      this.referUrl = res.data.url;
    },
      (err: any) => {
        console.log('DashFx error response', err);
      }
    );
  }

  async claimStake() {
    console.log('Claim called');
    this.swapStatus = SwapStatus.in_progess
    const { request } = await prepareWriteContract({
      ...presaleContractEth,
      functionName: 'claimAndStake',
      chainId: environment.eth.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('claimStake success', success);
        this.checkTRansaction(success.hash, 'claimstake', 0, 0);   // checking transaction status
      },
        (err: any) => {
          console.log('claimStake error', err);
          this.swapStatus = SwapStatus.failed
        });
  }

  async claimStakeRewards() {
    console.log('Claim called');
    const { request } = await prepareWriteContract({
      ...stakeContract,
      functionName: 'harvestRewards',
      chainId: environment.eth.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('claimStake success', success);
      },
        (err: any) => {
          console.log('claimStake error', err);
        });
  }

  async withdrawStake() {
    console.log('Claim called');
    const { request } = await prepareWriteContract({
      ...stakeContract,
      functionName: 'withdraw',
      chainId: environment.eth.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('claimStake success', success);
      },
        (err: any) => {
          console.log('claimStake error', err);
        });
  }

  async createStake(amount: any) {
    const allowanceData = await readContracts({
      contracts: [
        {
          ...tokenContract,
          functionName: 'allowance',
          chainId: this.chainId,
          args: [this.walletAddress, environment.stakingAddress],
        },
      ],
    })
    console.log('createStake allowanceData =', allowanceData);
    const allowanceValue = +formatEther(allowanceData[0].result as any);
    const amountEther = +amount;
    // const allowanceValue = allowanceData[0] as any;
    console.log(amountEther, allowanceValue, amount);

    if (amountEther > +allowanceValue) {
      const { request } = await prepareWriteContract({
        ...tokenContract,
        chainId: this.chainId,
        functionName: 'approve',
        args: [environment.stakingAddress, '100000000000000000000000000'],
        // account: this.walletAddress  // Optional param. Not required!

      })

      console.log('approveConfig =', request)
      this.swapStatus = SwapStatus.approval_pending;
      const { hash } = await writeContract(request);
      console.log('createStake approveConfig hash =', hash)
      await waitForTransaction({ hash })
        .then((success: any) => {
          console.log('approveConfig approve Config success', success);
          this.swapStatus = SwapStatus.confirm_pending;
          this.proceedCreateStake(amount);
        },
          (err: any) => {
            console.log('approve Config error', err);
            this.swapStatus = SwapStatus.rejected;
          });
    } else {
      this.proceedCreateStake(amount);
    }
  }


  async proceedCreateStake(amount: any) {

    const { request } = await prepareWriteContract({
      ...stakeContract,
      functionName: 'deposit',
      chainId: environment.eth.chainIdInt,
      args: [parseEther(amount.toString())]
    })

    this.swapStatus = SwapStatus.confirm_pending;
    await writeContract(request)
      .then((success: any) => {
        console.log('proceedCreateStake success', success);
        this.swapStatus = SwapStatus.in_progess;
        this.checkTRansaction(success.hash, '', amount, 0);
      },
        (err: any) => {
          console.log('Eth createStake error', err);
          this.swapStatus = SwapStatus.rejected;
        });
  }
}
